<div class="wrap p-l-0-l p-l-0-x p-r-0-l p-r-0-x">
    <div class="flex">
        <div class="left-column pos-relative">
            <store-finder [noGeolocationOnInit]="true"
                          #storeFinder
                          (storesUpdate)="onStoresUpdate($event)"
                          class="fill-x fill-l flex p-l-10 p-r-5 p-t-8 p-t-5-s p-t-5-m p-l-0-s p-l-0-m p-r-0-s p-r-0-m"></store-finder>
        </div>
        <div class="right-column ratio-5-4"
             *ifSize="'XL'">
            <google-map class="fill"
                        [fitBounds]="true"
                        [stores]="stores"
                        (storeSelected)="onStoreMarkerClicked($event)"
                        [markerLimit]="1000">
            </google-map>
        </div>
    </div>
</div>